import * as Constants from '../../utils/constants';

export const logFeedbackData = (data: any) => ({
    type: Constants.LPE_FEEDBACK_EVENTS,
    payload: data
  });